module.exports = __webpack_public_path__ + "static/logo-colored-b5bb73a7d3c2b1905ed12990dfecb30a.png";